import MainComponent from "components/Main";

import Search from "components/Search";
import ListDoctors from "components/ListDoctors";
import ContentBlock from "components/ContentBlock";
import ItemPerson from "components/ItemPerson";

import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class SelectDoctor extends MainComponent {
    static propTypes = {
        type: PropTypes.string,
        searchPlaceHolder: PropTypes.string,
        value: PropTypes.number,
        label: PropTypes.string,
        onClick: PropTypes.func,
    };
    static defaultProps = {
        type: "doctor",
        searchPlaceHolder: "main.searchDoctor",
        value: null,
        label: "",
        onClick: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search: "",
        };
    }

    selectItem(id) {
        const { onClick } = this.props;

        this.state.search = "";

        if (onClick?.apply)
            onClick(id);
    }

    getById(id) {
        if (!id)
            return null;

        const info = globalThis.appPageView.getDoctorById(id);

        return info?.id ? info : null;
    }

    render() {
        const { search } = this.state;
        const { value, label, type, searchPlaceHolder, hide } = this.props;

        const selected = this.getById(value);

        return (
            <div className="selectDoctor flex col gap16">
                <div className="flex col gap8">
                    {!!label && (
                        <div className="label text p2">{this.tr(label)}</div>
                    )}
                    {!selected ? (
                        <Search
                            placeHolder={searchPlaceHolder}
                            itemStyle={"search"}
                            onChange={this.changeState.bind(this, "search")}
                        />
                    ) : (
                        <ItemPerson
                            info={selected}
                            removeCb={this.selectItem.bind(this, null)}
                            active={true}
                        />
                    )}
                </div>
                {(!selected && (!hide || search)) && (
                    <ContentBlock noTitle={true} itemStyle="bodySelDoctor scrolling">
                        <ListDoctors
                            gap="gap4"
                            search={search}
                            type={type}
                            onClick={this.selectItem.bind(this)}
                        />
                    </ContentBlock>
                )}
            </div>
        );
    }
}
